export default {
  text: 'white',
  primary: '#f4c200',
  secondary: '#f4c200',
  background: 'black',
  backgroundSecondary: '#4a4a4a',
  light: '#FFF',
  dark: '#4a4a4a'
}
